/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useRef } from 'react';
import PropTypes from 'prop-types';

// components
import CardBase from 'ui-cardbase';
import Step from './Step/Step';

// assets
import iconDownload from '../../../assets/img/icon-download.svg';
import iconNextStepEmail from '../../../assets/img/icon-next-step-email.svg';
import iconNextStepPassCoopeuch from '../../../assets/img/icon-next-step-pass-coopeuch-gray.svg';
import iconNextStepPaymentParticipationFees from '../../../assets/img/icon-next-step-payment-participation-fees-gray.svg';

import { StyledWrapperCardBaseButtons } from '../../../assets/styles/styles';


const CardNextSteps = (props) => {
  const { email, isMobileDevice, onDownloadComponentPdf } = props;
  const refNextSteps = useRef(null);

  const nextSteps = [
    {
      name: 'nextStepEmail',
      title: 'Recibirás un email de confirmación',
      icon: iconNextStepEmail,
      state: {
        active: true,
        text: '¡Estás aquí!',
      },
      content: (
        <p>
          Se envió una copia de tus contratos firmados al correo <strong>{email || ''}</strong>{' '}
        </p>
      ),
    },
    {
      name: 'nextStepPassCoopeuch',
      title: 'Descarga PassCoopeuch para transacciones seguras',
      icon: iconNextStepPassCoopeuch,
      state: {
        active: false,
        text: '',
      },
      content: (
        <p>
          Te invitamos a descargar PassCoopeuch desde tu teléfono celular para que puedas autorizar
          tus transacciones de forma fácil, rápida y segura.
        </p>
      ),
    },
    {
      name: 'paymentParticipationFees',
      title: 'Revisa y paga tus cuotas cada mes',
      icon: iconNextStepPaymentParticipationFees,
      state: {
        active: false,
        text: '',
      },
      content: (
        <p>
          Recuerda el próximo mes realizar el pago de tus cuotas de participación en la sección pago
          online de Coopeuch.cl. También a través de Sencillito, Servipag y nuestras sucursales.
        </p>
      ),
    },
  ];

  const ButtonsCardBase = () => {
    return (
      <StyledWrapperCardBaseButtons>
        <button
          type="button"
          onClick={() =>
            onDownloadComponentPdf(/* refNextSteps */ 'nextStepsComponent', 'próximos_pasos')
          }
          disabled={false}
        >
          <img src={iconDownload} width="20" height="20" alt="download icon" />
          {!isMobileDevice && <span>Descargar</span>}
        </button>
      </StyledWrapperCardBaseButtons>
    );
  };
  return (
    <section id="nextStepsComponent" ref={refNextSteps}>
      <CardBase
        title="Próximos pasos"
        subtitle="Es importante que sigas con los pasos detallados a continuación"
        noPadding
        Buttons={<ButtonsCardBase />}
        shadedOutline
      >
        <>
          {nextSteps.map((step, index) => {
            return (
              <Step
                key={`step-${index}`}
                step={step}
                position={index + 1}
                isMobileDevice={isMobileDevice}
              />
            );
          })}
        </>
      </CardBase>
    </section>
  );
};

CardNextSteps.defaultProps = {
  email: '',
  isMobileDevice: false,
  onDownloadComponentPdf: () => null,
};
CardNextSteps.propTypes = {
  email: PropTypes.string,
  isMobileDevice: PropTypes.bool,
  onDownloadComponentPdf: PropTypes.func,
};

export default CardNextSteps;
